module.exports = __webpack_public_path__ + "static/media/noun_add_2664285_1.630326e9.svg";